//
//
//
//
//
//
//

export default {
  name: 'rb-rox-upload-prescription',
  props: {
    uploadPrescriptionObject: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  computed: {
    fileData() {
      return (
        this.uploadPrescriptionObject.uploadPrescriptionFile ||
        this.uploadPrescriptionObject.fileData
      )
    },
    isPDF() {
      return this.fileData?.substring(0, 20)?.includes('pdf')
    },
  },
}
